/** @format */

import {Table, TableCell, TableRow} from '@mui/material';
import {Trans} from 'react-i18next';

import {ActualKPI, StyledTableBody, StyledTableContainer, StyledTableHead} from '../../styles';
import ShowTypeIcon from '../ShowTypeIcon';
import {RSAPlatformTableProps} from './interfaces';

const RSAPlatformTable = ({data}: RSAPlatformTableProps) => (
  <StyledTableContainer>
    <Table>
      <StyledTableHead>
        <TableRow>
          <TableCell>
            <Trans>Субаккаунт</Trans>
          </TableCell>
          <TableCell>
            <Trans>Тип кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>Площадка РСЯ</Trans>
          </TableCell>
          <TableCell>
            <Trans>Плановый KPI</Trans>
          </TableCell>
          <TableCell>
            <Trans>Фактический KPI</Trans>
          </TableCell>
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.subAccount}</TableCell>
            <TableCell>
              <ShowTypeIcon showType={row.showType} />
            </TableCell>
            <TableCell>{row.platform}</TableCell>
            <TableCell>{row.plannedKPI}</TableCell>
            <TableCell>
              <ActualKPI>{row.actualKPI}</ActualKPI>
            </TableCell>
          </TableRow>
        ))}
      </StyledTableBody>
    </Table>
  </StyledTableContainer>
);

export default RSAPlatformTable;
